var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "error-content",
        {
          attrs: {
            code: "Sorry！",
            desc: _vm.$t("system::common::no_authority"),
            src: _vm.src,
          },
        },
        [
          _vm.authorizationCode
            ? _c("template", { slot: "btn_back" }, [
                _c("div", { staticClass: "auth-code" }, [
                  _vm._v("专属授权码：" + _vm._s(_vm.authorizationCode)),
                ]),
              ])
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }